import Vue from "vue";
import VueRouter from "vue-router";
import Auth from "@/utilities/auth";
import { icon } from "leaflet";

Vue.use(VueRouter);

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [
        {
            path: "/FuelStorage/BuyingFuel",
            name: "buying-fuel",
            component: () => import("@/views/fuel-storage/buying-fuel/BuyingFuelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["BUYING_FUEL_LIST"], // Role management might be needed later
                pageTitle: "Dışarıdan Alınan Yakıtlar",
                icon: "add_shopping_cart",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Dışarıdan Alınan Yakıtlar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/FuelStorage/TransferFuel",
            name: "transfer-fuel",
            component: () => import("@/views/fuel-storage/draining-fuel/TransferFuelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TRANSFER_FUEL"],
                pageTitle: "Araçtan Yakıt Tahliyesi/Transferi",
                icon: "sync_alt",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Araçtan Yakıt Tahliyesi/Transferi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/",
            name: "home",
            component: () => import("@/views/home/HomeView.vue"),
            meta: {
                requiresAuth: true,
                icon: "home",
                pageTitle: "Ana Sayfa",
                breadcrumb: [
                    {
                        text: "Anasayfa",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Auth/Login",
            name: "login",
            component: () => import("@/views/auth/LoginView.vue"),
            meta: {
                layout: "full",
                anonymous: true,
            },
        },
        {
            path: "/Auth/ForgotPassword",
            name: "forgot-password",
            component: () => import("@/views/auth/ForgotPasswordView.vue"),
            meta: {
                layout: "full",
                anonymous: true,
            },
        },
        {
            path: "/Auth/PasswordRecover/:key/:email",
            name: "recovery-password",
            component: () => import("@/views/auth/PasswordRecoverView.vue"),
            meta: {
                layout: "full",
                anonymous: true,
            },
        },
        {
            path: "/Profile",
            name: "profile",
            component: () => import("@/views/profile/ProfileView.vue"),
            meta: {
                requiresAuth: true,
                icon: "account_circle",
                pageTitle: "Profil Yönetimi",
                breadcrumb: [
                    {
                        text: "Profil Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/User",
            name: "user",
            component: () => import("@/views/user/UserView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["USER_LIST"],
                icon: "account_circle",
                pageTitle: "Kullanıcı Yönetimi",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Kullanıcı Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/UserActionLog",
            name: "user-action-log",
            component: () => import("@/views/system-definitions/log-operations/UserActionLogView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["USER_ACTION_LOG_LIST_VIEW"],
                icon: "sync_alt",
                pageTitle: "Kullanıcı İşlem Geçmişi",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Kullanıcı İşlem Geçmişi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemDefinitions/IntegrationInformation",
            name: "integration-information",
            component: () => import("@/views/system-definitions/integration-information/IntegrationInformationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["COMPANY_INTEGRATION_INFORMATION_LIST"],
                icon: "integration_instructions",
                pageTitle: "Entegrasyon Bilgileri",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Entegrasyon Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemDefinitions/Role",
            name: "role",
            component: () => import("@/views/system-definitions/role/RoleView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ROLE_LIST"],
                icon: "settings_accessibility",
                pageTitle: "Rol Yönetimi",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Rol Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemDefinitions/MobileApp",
            name: "mobile-app",
            component: () => import("@/views/system-definitions/mobile-app/MobileAppView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TABLET_LIST"],
                icon: "tablet_android",
                pageTitle: "Mobil Cihaz Yönetimi",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Mobil Cihaz Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemDefinitions/MailSettings",
            name: "mail-settings",
            component: () => import("@/views/system-definitions/mail-settings/MailSettingsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["MAIL_LIST"],
                icon: "mail_outline",
                pageTitle: "Mail Yönetimi",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Mail Yönetimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemDefinitions/Template",
            name: "template",
            component: () => import("@/views/template-generator/TemplateView.vue"),
            meta: {
                pageTitle: "Belge Şablonları",
                requiresRole: ["DOCUMENT_TEMPLATE_LIST"],
                icon: "space_dashboard",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Belge Şablonları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemDefinitions/TemplateGenerator/:id",
            name: "template-generator",
            component: () => import("@/views/template-generator/TemplateGeneratorView.vue"),
            meta: {
                pageTitle: "Belge Şablonu İşlemi",
                requiresRole: ["DOCUMENT_TEMPLATE_LIST"],
                icon: "space_dashboard",
                breadcrumb: [
                    {
                        text: "Sistem Yönetimi",
                        active: true,
                    },
                    {
                        text: "Belge Şablonları",
                        active: false,
                        to: "/SystemDefinitions/Template",
                    },
                    {
                        text: "Belge Şablonu İşlemi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleDefinitions/VehicleBrand",
            name: "vehicle-brand",
            component: () => import("@/views/vehicle-definitions/brand/BrandView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_BRAND_LIST"],
                icon: "branding_watermark",
                pageTitle: "Marka",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Parametreleri",
                        active: true,
                    },
                    {
                        text: "Marka",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SectorTypeOperations",
            name: "sector-type",
            component: () => import("@/views/sector-type/SectorTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SECTOR_TYPE_OPERATIONS"],
                icon: "swipe",
                pageTitle: "Sektör Tipi",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Firma Parametreleri",
                        active: true,
                    },
                    {
                        text: "Sektör Tipi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleDefinitions/VehicleBrandModel",
            name: "vehicle-brand-model",
            component: () => import("@/views/vehicle-definitions/brand-model/BrandModelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_MODEL_LIST"],
                icon: "model_training",
                pageTitle: "Model",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Parametreleri",
                        active: true,
                    },
                    {
                        text: "Model",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleDefinitions/VehicleModelSerial",
            name: "vehicle-brand-model-serial",
            component: () => import("@/views/vehicle-definitions/brand-model-serial/BrandModelSerialView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_MODEL_SERIAL_LIST"],
                icon: "unfold_less",
                pageTitle: "Model Serisi",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Parametreleri",
                        active: true,
                    },
                    {
                        text: "Model Serisi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleDefinitions/VehicleType",
            name: "vehicle-type",
            component: () => import("@/views/vehicle-definitions/type/TypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_TYPE_LIST"],
                icon: "rv_hookup",
                pageTitle: "Araç Tipi",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Tipi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleDefinitions/Vehicle",
            name: "vehicle",
            component: () => import("@/views/vehicle-definitions/vehicle/VehicleView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_LIST"],
                pageTitle: "Araç",
                icon: "commute",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleDefinitions/TireSize",
            name: "tire-size",
            component: () => import("@/views/vehicle-definitions/tire-size/TireSizeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TIRE_SIZE_LIST"],
                icon: "tire_repair",
                pageTitle: "Lastik Ölçüsü",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Araç Parametreleri",
                        active: true,
                    },
                    {
                        text: "Lastik Ölçüsü",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Fuel/Prices",
            name: "fuel-prices",
            component: () => import("@/views/fuel/PricesView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PRICE_OPERATIONS_LIST"],
                icon: "local_gas_station",
                pageTitle: "Yakıt Fiyatları",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Yakıt Fiyatları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Currency",
            name: "currency",
            component: () => import("@/views/currency/CurrencyView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["CURRENCY_RATE_LIST"],
                icon: "currency_exchange",
                pageTitle: "Döviz Kurları",
                breadcrumb: [
                    {
                        text: "Güncel Veriler",
                        active: true,
                    },
                    {
                        text: "Döviz Kurları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Inflation",
            name: "inflation",
            component: () => import("@/views/inflation/InflationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["INFLATION_INFORMATION_LIST"],
                icon: "query_stats",
                pageTitle: "Enflasyon Göstergeleri",
                breadcrumb: [
                    {
                        text: "Güncel Veriler",
                        active: true,
                    },
                    {
                        text: "Enflasyon Göstergeleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/DocumentOperations/VehicleInventory",
            name: "vehicle-inventory-document-definition",
            component: () => import("@/views/document-operations/vehicle-inventory/VehicleInventoryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_DOCUMENT_LIST"],
                icon: "picture_as_pdf",
                pageTitle: "Araç Belge",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Araç Belge",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/DocumentOperations/EmployeeDocument",
            name: "employee-document",
            component: () => import("@/views/document-operations/employee-document/EmployeeDocumentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["PERSONEL_DOCUMENT_LIST"],
                icon: "picture_as_pdf",
                pageTitle: "Personel Belge",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Personel Belge",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleOperations/Inventory/Operational",
            name: "vehicle-inventory-operational",
            component: () => import("@/views/vehicle-operations/operational-inventory/OperationalInventoryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["OPERATIONAL_VEHICLE_INVENTORY_LIST"],
                icon: "track_changes",
                pageTitle: "Operasyonel Araç Envanteri İşlemleri",
                breadcrumb: [
                    {
                        text: "Envanter İşlemleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Araç Envanteri İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleOperations/Inventory/PlateHistory",
            name: "vehicle-plate-history",
            component: () => import("@/views/vehicle-operations/vehicle-plate/PlateHistory.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["OPERATIONAL_VEHICLE_INVENTORY_LIST"],
                icon: "history",
                pageTitle: "Plaka İşlem Geçmişi",
                breadcrumb: [
                    {
                        text: "Envanter İşlemleri",
                        active: true,
                    },
                    {
                        text: "Plaka İşlem Geçmişi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleOperations/Inventory",
            name: "vehicle-inventory-definition",
            component: () => import("@/views/vehicle-operations/inventory/InventoryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_INVENTORY_LIST"],
                icon: "featured_play_list",
                pageTitle: "Envanter İşlemleri",
                breadcrumb: [
                    {
                        text: "Envanter İşlemleri",
                        active: true,
                    },
                    {
                        text: "Araç Envanter İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleOperations/Inventory/CreateOrUpdate/:id",
            name: "inventory-create-or-update",
            component: () => import("@/views/vehicle-operations/inventory/InventoryCreateOrUpdateView.vue"),
            meta: {
                requiresAuth: true,
                icon: "featured_play_list",
                pageTitle: "Envanter İşlemleri",
                breadcrumb: [
                    {
                        text: "Envanter İşlemleri",
                        active: true,
                    },
                    {
                        text: "Araç Envanter Tanımlama",
                        active: false,
                        to: "/VehicleOperations/Inventory",
                    },
                    {
                        text: "Araç Envanter Tanımlama İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleOperations/Garage",
            name: "garage",
            component: () => import("@/views/vehicle-operations/garage/GarageView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_GARAGE_LIST"],
                icon: "garage",
                pageTitle: "Garaj",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Garaj",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SystemConstants",
            name: "system-constant-parameters",
            component: () => import("@/views/system-constant-parameters/SystemConstantParameterView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SYSTEM_CONSTANT_LIST"],
                icon: "data_object",
                pageTitle: "Sistem Sabitleri",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Sistem Değişkenleri",
                        active: true,
                    },
                    {
                        text: "Sistem Sabitleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HRConstants",
            name: "hr-constant-parameters",
            component: () => import("@/views/hr-constant-parameters/HRConstantParameterView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_CONSTANT_LIST"],
                icon: "data_object",
                pageTitle: "İnsan Kaynakları Sabitleri",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Sistem Değişkenleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları Sabitleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/TotalFleet",
            name: "total-fleet",
            component: () => import("@/views/total-fleet-operations/TotalFleetView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TOTAL_FLEET_PROCESS"],
                icon: "meeting_room",
                pageTitle: "Sistem Sabitleri",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Sistem Değişkenleri",
                        active: true,
                    },
                    {
                        text: "Total Yakıt Filosu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VehicleOperations/Plate",
            name: "plate",
            component: () => import("@/views/vehicle-operations/plate/PlateView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["PLATE_INVENTORY_LIST"],
                icon: "tablet",
                pageTitle: "Plaka Envanteri",
                breadcrumb: [
                    {
                        text: "Envanter İşlemleri",
                        active: true,
                    },
                    {
                        text: "Plaka Envanteri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/WorkingGroup",
            name: "working-group",
            component: () => import("@/views/operational-parameters/working-group/WorkingGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WORKING_GROUP_LIST"],
                icon: "diversity_2",
                pageTitle: "Çalışma Grubu",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Çalışma Grubu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/MainGroup",
            name: "shipable-product-main-group",
            component: () => import("@/views/shipable-product/main-group/MainGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_MAIN_GROUP_LIST"],
                icon: "group_work",
                pageTitle: "Ana Grup",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Ana Grup",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/SubGroup",
            name: "shipable-product-sub-group",
            component: () => import("@/views/shipable-product/sub-group/SubGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_SUP_GROUP_LIST"],
                icon: "category",
                pageTitle: "Alt Grup",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Alt Grup",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/Form",
            name: "shipable-product-form",
            component: () => import("@/views/shipable-product/form/FormView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_FORM_LIST"],
                pageTitle: "Yük Şekli",
                icon: "dashboard",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Yük Şekli",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/DangerClass",
            name: "shipable-product-danger-class",
            component: () => import("@/views/shipable-product/danger-class/DangerClassView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_DANGER_CLASS_LIST"],
                pageTitle: "Tehlike Sınıfı",
                icon: "local_fire_department",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Tehlike Sınıfı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/ValueClass",
            name: "shipable-product-value-class",
            component: () => import("@/views/shipable-product/value-class/ValueClassView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_VALUE_CLASS_LIST"],
                icon: "diamond",
                pageTitle: "Değer Sınıfı",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Değer Sınıfı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/LoadMode",
            name: "shipable-product-load-mode",
            component: () => import("@/views/shipable-product/load-mode/LoadModeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_LOAD_MODE_LIST"],
                pageTitle: "Yükleme Modu",
                icon: "publish",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Yükleme Modu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct/LoadType",
            name: "shipable-product-load-type",
            component: () => import("@/views/shipable-product/load-type/LoadTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_LOAD_TYPE_LIST"],
                pageTitle: "Yükleme Tipi",
                icon: "publish",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Yükleme Tipi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/ShipableProduct",
            name: "shipable-product",
            component: () => import("@/views/shipable-product/product/ProductView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIPABLE_PRODUCT_LIST"],
                pageTitle: "Yük",
                icon: "inventory_2",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Taşınabilir Yükler",
                        active: true,
                    },
                    {
                        text: "Yük",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/CarrierClassification",
            name: "carrier-classification",
            component: () => import("@/views/operational-parameters/carrier-classification/CarrierClassificationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["CARRIER_CLASSIFICATION_LIST"],
                pageTitle: "Nakliyeci Sınıfı",
                icon: "stroller",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Nakliyeci Sınıfı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/LevyOffice",
            name: "op-levy-office",
            component: () => import("@/views/operational-parameters/levy-office/LevyOfficeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LEVY_OFFICE_LIST"],
                pageTitle: "İcra Dairesi",
                icon: "point_of_sale",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "İcra Dairesi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/Province",
            name: "op-province",
            component: () => import("@/views/operational-parameters/province/ProvinceView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "İl",
                icon: "map",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "İl",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/ProvinceIndexCategory",
            name: "op-province-index-category",
            component: () => import("@/views/operational-parameters/province-index-category/ProvinceIndexCategoryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "İl Endeks Kategorileri",
                icon: "layers",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "İl Endeks Kategorileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/District",
            name: "op-district",
            component: () => import("@/views/operational-parameters/district/DistrictView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "İlçe",
                icon: "map",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "İlçe",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/Street",
            name: "op-street",
            component: () => import("@/views/operational-parameters/street/Street.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "Sokak",
                icon: "map",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Sokak",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/Neighborhood",
            name: "op-neighborhood",
            component: () => import("@/views/operational-parameters/neighborhood/Neighborhood.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "Mahalle",
                icon: "map",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Mahalle",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/HGSGise",
            name: "op-hgs-gise",
            component: () => import("@/views/operational-parameters/hgs-gise/HGSGiseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["IS_BANKASI_HGS_TRANSITION_INFORMATION_LIST"],
                pageTitle: "HGS Geçiş İşlemleri",
                icon: "toll",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "HGS Geçiş İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/TaxAdministration",
            name: "op-tax-administration",
            component: () => import("@/views/operational-parameters/tax-administration/TaxAdministrationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TAX_ADMINISTRATION_LIST"],
                pageTitle: "Vergi Ofisi",
                icon: "assured_workload",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Vergi Ofisi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/OperationalParameters/TrafficFine",
            name: "traffic-fine-operation",
            component: () => import("@/views/operational-parameters/traffic-fine/TrafficFineView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TRAFFIC_FINE_DEFINITION_OPERATION"],
                pageTitle: "Trafik Cezaları",
                icon: "traffic",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Operasyonel Parametreler",
                        active: true,
                    },
                    {
                        text: "Trafik Cezaları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Firm",
            name: "firm-operations",
            component: () => import("@/views/firm-operations/firm/FirmView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FIRM_LIST"],
                pageTitle: "Firma İşlemleri",
                icon: "store",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Firma",
                        active: true,
                    },
                    {
                        text: "Firma İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Firm/Parent",
            name: "firm-operations-parent",
            component: () => import("@/views/firm-operations/parent-firm/ParentFirmView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FIRM_LIST"],
                pageTitle: "Ana Firma İşlemleri",
                icon: "cottage",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Firma",
                        active: true,
                    },
                    {
                        text: "Ana Firma İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Firm/Create",
            name: "firm-create",
            component: () => import("@/views/firm-operations/firm/FirmCreateView.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: "Firma İşlemleri",
                icon: "store",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Firma",
                        active: false,
                        to: "/Firm",
                    },
                    {
                        text: "Firma İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CalculatePrice/ReferenceModel",
            name: "vehicle-reference-model",
            component: () => import("@/views/calculate-price/reference-model/ReferenceModelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VEHICLE_REF_MODEL_LIST"],
                pageTitle: "Araç Referans Model",
                icon: "architecture",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Fiyat Çalışma",
                        active: true,
                    },
                    {
                        text: "Araç Referans Model",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CalculatePrice/TireReferenceModel",
            name: "tire-reference-model",
            component: () => import("@/views/calculate-price/tire-reference-model/TireReferenceModelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TIRE_REF_MODEL_LIST"],
                pageTitle: "Lastik Referans Model",
                icon: "circle",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Fiyat Çalışma",
                        active: true,
                    },
                    {
                        text: "Lastik Referans Model",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CalculatePrice/ReferenceModel/CreateOrUpdate/:id",
            name: "vehicle-reference-model-create-or-update",
            component: () => import("@/views/calculate-price/reference-model/ReferenceModelCreateOrUpdateView.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: "Araç Referans Model İşlemi",
                icon: "architecture",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Fiyat Çalışma",
                        active: true,
                    },
                    {
                        text: "Araç Referans Model",
                        active: false,
                        to: "/CalculatePrice/ReferenceModel",
                    },
                    {
                        text: "Araç Referans Model İşlemi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CalculatePrice/DraftPrice",
            name: "draft-price",
            component: () => import("@/views/calculate-price/draft-price/DraftPriceView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["DRAFT_OFFER_PRICE_LIST"],
                pageTitle: "Taslak Fiyat",
                icon: "design_services",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Fiyat Çalışma",
                        active: true,
                    },
                    {
                        text: "Taslak Fiyat",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CalculatePrice/DraftPrice/Create",
            name: "draft-price-create-or-update",
            component: () => import("@/views/calculate-price/draft-price/DraftPriceCreateView.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: "Taslak Fiyat Çalışma Alanı",
                icon: "design_services",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Fiyat Çalışma",
                        active: true,
                    },
                    {
                        text: "Taslak Fiyat",
                        active: false,
                        to: "/CalculatePrice/DraftPrice",
                    },
                    {
                        text: "Taslak Fiyat Çalışma Alanı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Agreement",
            name: "agreement",
            component: () => import("@/views/agreement/AgreementView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["AGREEMENT_LIST"],
                pageTitle: "Sözleşme",
                icon: "draw",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Sözleşme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/ActualLocation",
            name: "seyir-actual-location",
            component: () => import("@/views/seyir/seyir-actual-location/SeyirActualLocation.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "Canlı Araç Takip",
                icon: "stream",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Canlı Araç Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/LocationLogs",
            name: "seyir-location-logs",
            component: () => import("@/views/seyir/seyir-location-logs/SeyirLocationLogs.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Lokasyon Kayıtları (Geçmişe Dönük)",
                icon: "near_me",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Lokasyon Kayıtları (Geçmişe Dönük)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/LocationLogsForVehicle",
            name: "seyir-location-logs-for-vehicle",
            component: () => import("@/views/seyir/seyir-location-logs-for-vehicle/SeyirLocationLogsForVehicle.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Lokasyon Kayıtları (Araç)(Gün Aralığı)",
                icon: "near_me",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Lokasyon Kayıtları (Araç)(Gün Aralığı)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/LocationLogsForVehicleByDate",
            name: "seyir-location-logs-for-vehicle-by-date",
            component: () => import("@/views/seyir/seyir-location-logs-for-vehicle-by-date/SeyirLocationLogsForVehicleByDate.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Lokasyon Kayıtları (Araç)(Gün)",
                icon: "near_me",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Lokasyon Kayıtları (Araç)(Gün)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/PerformanceReport",
            name: "seyir-performance-report",
            component: () => import("@/views/seyir/seyir-performance-report/SeyirPerformanceReport.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Performans Raporu (Gün)(Saat Aralığı)",
                icon: "shutter_speed",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Performans Raporu (Gün)(Saat Aralığı)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/DateRangePerformanceReport",
            name: "seyir-date-range-performance-report",
            component: () => import("@/views/seyir/seyir-date-range-performance-report/SeyirDateRangePerformanceReport.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Performans Raporu (Gün Aralığı)(Saat Aralığı)",
                icon: "shutter_speed",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Performans Raporu (Gün Aralığı)(Saat Aralığı)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/VehicleDetailReport",
            name: "seyir-vehicle-detail-report",
            component: () => import("@/views/seyir/seyir-vehicle-detail-report/SeyirVehicleDetailReport.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Araç Detay Raporu (Gün)",
                icon: "summarize",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Araç Detay Raporu (Gün)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/AreaReport",
            name: "seyir-area-report",
            component: () => import("@/views/seyir/seyir-area-report/SeyirAreaReport.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Alan Raporu (Gün)",
                icon: "area_chart",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Alan Raporu (Gün)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CBS/AreaReportAndAreaEntrances",
            name: "seyir-area-report-and-area-entrances",
            component: () => import("@/views/seyir/seyir-area-report-and-area-entrances/SeyirAreaReportAndAreaEntrances.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SEYIR_ACTUAL_LOCATION"],
                pageTitle: "**Alan Raporu ve Alan Girişler (Gün Aralığı)",
                icon: "area_chart",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "CBS Verileri",
                        active: true,
                    },
                    {
                        text: "Alan Raporu ve Alan Girişler (Gün Aralığı)",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Agreement/Detail/:id",
            name: "agreement-detail",
            component: () => import("@/views/agreement/AgreementDetailView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["AGREEMENT_LIST"],
                pageTitle: "Sözleşme",
                icon: "draw",
                breadcrumb: [
                    {
                        text: "Operasyonel Süreçler",
                        active: true,
                    },
                    {
                        text: "Sözleşme",
                        to: "/Agreement",
                        active: false,
                    },
                    {
                        text: "Sözleşme Detay",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/NarliFerryboat",
            name: "narli-ferryboat",
            component: () => import("@/views/reports/narli-ferryboat/NarliFerryboatView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NARLI_FERRYBOAT_TRANSITON_INFORMATION_LIST"],
                pageTitle: "Geçiş Bilgileri",
                icon: "directions_boat",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Narlı Feribot Bilgileri",
                        active: true,
                    },
                    {
                        text: "Geçiş Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/NarliFerryboat/StatsByProcessType",
            name: "narli-ferryboat-stats-by-process-type",
            component: () => import("@/views/reports/narli-ferryboat/NarliFerryboatStatsByProcessTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NARLI_FERRYBOAT_REPORTS_BY_PROCESS_TYPE_LIST"],
                pageTitle: "Günlük Bazda - İşlem Tipine Göre Rapor",
                icon: "credit_card",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Narlı Feribot Bilgileri",
                        active: true,
                    },
                    {
                        text: "Günlük Bazda - İşlem Tipine Göre Rapor",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/NarliFerryboat/StatsByVehicleType",
            name: "narli-ferryboat-stats-by-vehicle-type",
            component: () => import("@/views/reports/narli-ferryboat/NarliFerryboatStatsByVehicleTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NARLI_FERRYBOAT_REPORTS_BY_VEHICLE_TYPE_LIST"],
                pageTitle: "Günlük Bazda - Araç Tipine Göre Rapor",
                icon: "local_shipping",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Narlı Feribot Bilgileri",
                        active: true,
                    },
                    {
                        text: "Günlük Bazda - Araç Tipine Göre Rapor",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/NarliFerryboat/StatsByPlate",
            name: "narli-ferryboat-stats-by-plate",
            component: () => import("@/views/reports/narli-ferryboat/NarliFerryboatStatsByPlateView.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: "Günlük Bazda - Plakaya Göre Rapor",
                icon: "tablet",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Narlı Feribot Bilgileri",
                        active: true,
                    },
                    {
                        text: "Günlük Bazda - Plakaya Göre Rapor",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/NarliFerryboat/StatsSummary",
            name: "narli-ferryboat-stats-by-date-range-summary",
            component: () => import("@/views/reports/narli-ferryboat/NarliFerryboatStatsByDateRangeSummaryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NARLI_FERRYBOAT_REPORTS_BY_BETWEEN_DATES_LIST"],
                pageTitle: "Tarih Aralığına Göre Özet Rapor",
                icon: "auto_graph",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Narlı Feribot Bilgileri",
                        active: true,
                    },
                    {
                        text: "Tarih Aralığına Göre Özet Rapor",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/IsBankasiHGS",
            name: "isbankasi-hgs",
            component: () => import("@/views/reports/isbankasi-hgs/IsBankasiHGSView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["IS_BANKASI_HGS_TRANSITION_INFORMATION_LIST"],
                pageTitle: "Geçiş Bilgileri",
                icon: "toll",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "İş Bankası HGS Bilgileri",
                        active: true,
                    },
                    {
                        text: "Geçiş Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/IsBankasiHGSCharge",
            name: "isbankasi-hgs-charge",
            component: () => import("@/views/reports/isbankasi-hgs-charge/IsBankasiHGSChargeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["IS_BANKASI_HGS_CHARGE_INFORMATION_LIST"],
                pageTitle: "Yükleme Bilgileri",
                icon: "credit_score",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "İş Bankası HGS Bilgileri",
                        active: true,
                    },
                    {
                        text: "Yükleme Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/TotalFuelLoad",
            name: "total-fuel-load",
            component: () => import("@/views/reports/total-fuel-load/TotalFuelLoad.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TOTAL_FUEL_LOAD_REPORT"],
                pageTitle: "Total Yakıt Yükleme Bilgileri",
                icon: "oil_barrel",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Total Yakıt Yükleme Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/POFuelLoad",
            name: "po-fuel-load",
            component: () => import("@/views/reports/po-fuel-load/PoFuelLoad.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TOTAL_FUEL_LOAD_REPORT"],
                pageTitle: "Petrol Ofisi Yakıt Yükleme Bilgileri",
                icon: "oil_barrel",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Petrol Ofisi Yükleme Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/POFiloCodes",
            name: "po-filo-codes",
            component: () => import("@/views/petrol-ofisi/PoFiloCodeDefinitions.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TOTAL_FUEL_LOAD_REPORT"],
                pageTitle: "Petrol Ofisi Filo Tanımları",
                icon: "settings",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Tanımlamalar",
                        active: true,
                    },
                    {
                        text: "Petrol Ofisi Filo Tanımları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CreditCardInformation",
            name: "credit-card-information",
            component: () => import("@/views/fuel-storage/credit-card-information/CreditCardInformation.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                pageTitle: "Kredi Kartı Tanımlama",
                icon: "credit_card",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Parametreler",
                        active: true,
                    },
                    {
                        text: "Kredi Kartı Tanımlama",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/RefineryPrice",
            name: "refinery-price",
            component: () => import("@/views/fuel-storage/refinery-price/RefineryPrice.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                pageTitle: "Rafineri Fiyatları",
                icon: "oil_barrel",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Parametreler",
                        active: true,
                    },
                    {
                        text: "Rafineri Fiyatları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SupplierAgreement",
            name: "supplier-agreement",
            component: () => import("@/views/fuel-storage/supplier-agreement/SupplierAgreement.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                pageTitle: "Tedarikçi Sözleşmeleri",
                icon: "handshake",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Parametreler",
                        active: true,
                    },
                    {
                        text: "Tedarikçi Sözleşmeleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/SupplierIskonto",
            name: "supplier-iskonto",
            component: () => import("@/views/fuel-storage/supplier-iskonto/SupplierIskonto.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                pageTitle: "İskonto Tanımlama",
                icon: "price_change",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Parametreler",
                        active: true,
                    },
                    {
                        text: "İskonto Tanımlama",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/AllShifts",
            name: "all-shifts",
            component: () => import("@/views/fuel-storage/shift/AllShifts.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIFT_INFORMATION_PROCESS_VIEW"],
                pageTitle: "Tüm Vardiya Bilgileri",
                icon: "work",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Vardiyalar",
                        active: true,
                    },
                    {
                        text: "Tüm Vardiya Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/MyShifts",
            name: "my-shifts",
            component: () => import("@/views/fuel-storage/shift/MyShifts.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SHIFT_INFORMATION_PROCESS_VIEW_SELF"],
                pageTitle: "Benim Vardiya Bilgilerim",
                icon: "work_history",
                breadcrumb: [
                    {
                        text: "Yakıt Yönetimi",
                        active: true,
                    },
                    {
                        text: "Vardiyalar",
                        active: true,
                    },
                    {
                        text: "Benim Vardiya Bilgilerim",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/Employee",
            name: "employee-basic-report",
            component: () => import("@/views/reports/employee/employee-basic/EmployeeBasicView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_GLOBAL_REPORT"],
                pageTitle: "Personel",
                icon: "groups_3",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/PersonnelReport",
            name: "personnel-report",
            component: () => import("@/views/reports/employee/personnel-report/PersonnelReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["PERSONNEL_REPORT_VIEW"],
                pageTitle: "Personel Raporu",
                icon: "groups_3",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/EmployeeExpense",
            name: "employee-reports-expense",
            component: () => import("@/views/reports/employee-expense/EmployeeExpenseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Personel Maliyet",
                icon: "currency_exchange",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Personel Maliyet",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/OHSEducation",
            name: "ohs-report",
            component: () => import("@/views/reports/ohs-education/OHSEducationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "İSG Eğitimi",
                icon: "emergency",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "İSG Eğitimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/SRC",
            name: "src-report",
            component: () => import("@/views/reports/src-report/SRCView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "SRC",
                icon: "emergency",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "SRC",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/HealthReport",
            name: "health-report-report",
            component: () => import("@/views/reports/health-report/HealtReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "Sağlık Raporu",
                icon: "emergency",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Sağlık Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/GSalaryReport",
            name: "report-g-salary-report",
            component: () => import("@/views/reports/gsalary-report/GSalaryReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Banka 2 Maaş Bordro Yükleme Takip",
                icon: "document_scanner",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Banka 2 Maaş Bordro Yükleme Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/RegistryDocument",
            name: "report-registry-document",
            component: () => import("@/views/reports/registry-document/RegistryDocumentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Sicil Dosyası Takip",
                icon: "document_scanner",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Sicil Dosyası Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/SicilFile",
            name: "report-sicil-file",
            component: () => import("@/views/reports/sicil-file/SicilFileView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Sicil Belgeleri Takip",
                icon: "document_scanner",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Sicil Belgeleri Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/ExitFile",
            name: "report-exit-file",
            component: () => import("@/views/reports/exit-file/ExitFileView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EXIT_DOCUMENT_REPORT_VIEW"],
                pageTitle: "Çıkış Evrakları Takip",
                icon: "logout",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Çıkış Evrakları Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/Psychotechnic",
            name: "psychotechnic-report",
            component: () => import("@/views/reports/psycho/PsychoView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "Psikoteknik",
                icon: "emergency",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Psikoteknik",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/EmployeeTrafficFinePerformance",
            name: "employee-traffic-fine-performance-report",
            component: () => import("@/views/reports/employee-traffic-fine-performance/EmployeeTrafficFinePerformanceView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "Performans Ceza Puanı Raporu",
                icon: "traffic",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Performans Ceza Puanı Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/EmployeeTrafficFineOfficial",
            name: "employee-traffic-fine-official-report",
            component: () => import("@/views/reports/employee-traffic-fine-official/EmployeeTrafficFineOfficialView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "Resmi Ceza Puanı Raporu",
                icon: "traffic",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Resmi Ceza Puanı Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/DigitalDriverLicense",
            name: "digital-driver-license-report",
            component: () => import("@/views/reports/digital-driver-license/DigitalDriverLicenseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "Dijital Ehliyet Takip",
                icon: "badge",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Dijital Ehliyet Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/DriverLicense",
            name: "driver-license-report",
            component: () => import("@/views/reports/driver-license/DriverLicenseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ISG_REPORT"],
                pageTitle: "Ehliyet Takip",
                icon: "badge",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Ehliyet Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/OrgChart",
            name: "org-chart",
            component: () => import("@/views/reports/org-chart/OrgChartView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_DEPARTMENT_LIST", "HR_PARAMS_DEPARTMENT_TITLES_LIST"],
                pageTitle: "Organizasyonel Şema",
                icon: "account_tree",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Organizasyonel Şema",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/EmployeeExpenseMonthly",
            name: "employee-reports-expense-monthly",
            component: () => import("@/views/reports/employee-expense-monthly/EmployeeExpenseMonthlyView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Personel Aylık Maliyet",
                icon: "currency_exchange",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Personel Aylık Maliyet",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/ProvinceIndexes",
            name: "report-province-indexes",
            component: () => import("@/views/reports/province-indexes/ProvinceIndexesView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "İl Katsayıları",
                icon: "share_location",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "İl Katsayıları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/MealPricesBasedByOrganisationalLocation",
            name: "report-meal-prices-based-by-organisational-location",
            component: () => import("@/views/reports/meal-prices-based-by-organisational-location/MealPricesBasedByOrganisationalLocationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "Organizasyonel Düzeylere Göre Yemek Ücretleri",
                icon: "restaurant",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Organizasyonel Düzeylere Göre Yemek Ücretleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/RoadPricesBasedByOrganisationalLocation",
            name: "report-road-prices-based-by-organisational-location",
            component: () => import("@/views/reports/road-prices-based-by-organisational-location/RoadPricesBasedByOrganisationalLocationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LOCATION_OPERATIONS"],
                pageTitle: "Organizasyonel Düzeylere Göre Yol Ücretleri",
                icon: "timeline",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Organizasyonel Düzeylere Göre Yol Ücretleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/IsBankasiHGSOperations/Application",
            name: "isbankasi-hgs-application",
            component: () => import("@/views/isbankasi-hgs-operations/isbankasi-hgs-application/IsBankasiHGSApplicationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["IS_BANKASI_HGS_APPLICATION"],
                pageTitle: "HGS Başvuru Talebi",
                icon: "credit_score",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "İş Bankası HGS",
                        active: true,
                    },
                    {
                        text: "HGS Başvuru Talebi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/IsBankasiHGSOperations/Cancel",
            name: "isbankasi-hgs-cancel",
            component: () => import("@/views/isbankasi-hgs-operations/isbankasi-hgs-cancel/IsBankasiHGSCancelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["IS_BANKASI_HGS_CANCEL_LIST"],
                pageTitle: "HGS İptal Talebi",
                icon: "credit_card_off",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "İş Bankası HGS",
                        active: true,
                    },
                    {
                        text: "HGS İptal Talebi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographDriver",
            name: "tachograph-driver-operations",
            component: () => import("@/views/employee-operations/tachograph-driver/TachographDriverOperationsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_LIST"],
                pageTitle: "Tüm Sürücü Bilgileri",
                icon: "contact_emergency",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Tüm Sürücü Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographWorkingTime",
            name: "tachograph-driver-working-time",
            component: () => import("@/views/employee-operations/tachograph-driver-working-time/TachographDriverWorkingTimeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_WORKING_LIST"],
                pageTitle: "Sürücü Çalışma Zamanı",
                icon: "contact_emergency",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Sürücü Çalışma Zamanı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographWrongData",
            name: "tachograph-wrong-driver-data",
            component: () => import("@/views/employee-operations/tachograph-wrong-driver-data/TachographWrongDriverData.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_WRONG_DATA_LIST"],
                pageTitle: "Hatalı Sürücü Verileri",
                icon: "rule",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Hatalı Sürücü Verileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographVehicleDriverCardMovement",
            name: "tachograph-vehicle-driver-card-movement",
            component: () => import("@/views/employee-operations/tachograph-vehicle-driver-card-movement/TachographVehicleDriverCardMovement.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_VEHICLE_DRIVER_CARD_MOVEMENT_LIST"],
                pageTitle: "Araç Sürücü Ehliyet Hareketleri",
                icon: "badge",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Araç Sürücü Ehliyet Hareketleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographOutOfInventoryPlateData",
            name: "tachograph-out-of-inventory-plate-data",
            component: () => import("@/views/employee-operations/tachograph-out-of-inventory-plate-data/TachographOutOfInventoryPlateDataView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_WRONG_DATA_LIST"],
                pageTitle: "Envanter Dışı Plakalar",
                icon: "rule",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Envanter Dışı Plakalar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographVehicle",
            name: "tachograph-vehicle-operations",
            component: () => import("@/views/employee-operations/tachograph-vehicle/TachographVehicleOperationsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_VEHICLE_LIST"],
                pageTitle: "Tüm Araç Bilgileri",
                icon: "car_repair",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Tüm Araç Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TachographUploadTracing",
            name: "tachograph-upload-tracing",
            component: () => import("@/views/employee-operations/tachograph-upload-tracing/TachographUploadTracingView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_LIST"],
                pageTitle: "Sürücü Yükleme Takip",
                icon: "cloud_sync",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Sürücü Yükleme Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/SeyirDriverDownloadTracing",
            name: "seyir-driver-download-tracing",
            component: () => import("@/views/employee-operations/seyir-driver-download-tracing/SeyirDriverDownloadTracingView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_LIST"],
                pageTitle: "Seyir Sürücü Dosya İndirme Takip",
                icon: "cloud_download",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Takograf",
                        active: true,
                    },
                    {
                        text: "Seyir Sürücü Dosya İndirme Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Employee",
            name: "employee",
            component: () => import("@/views/employee-operations/employee/EmployeeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Personel İşlemleri",
                icon: "people",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/CreateOrUpdate/:id",
            name: "employee-create-or-update",
            component: () => import("@/views/employee-operations/employee/EmployeeCreateOrUpdateView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Personel İşlemi",
                icon: "people",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: false,
                        to: "/EmployeeOperations/Employee",
                    },
                    {
                        text: "Personel İşlemi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Candidate/CreateOrUpdate/:id",
            name: "candidate-employee-create-or-update",
            component: () => import("@/views/employee-operations/employee/EmployeeCreateOrUpdateView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Aday Personel İşlemi",
                icon: "people",
                candidate: true,
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: false,
                        to: "/EmployeeOperations/Employee",
                    },
                    {
                        text: "Aday Personel İşlemi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/NotMathcedEmployee",
            name: "not-matched-employee",
            component: () => import("@/views/employee-operations/not-matched-employee/NotMatchedEmployeeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TACHOGRAPH_NOT_MATCHED_EMPLOYEE"],
                pageTitle: "Eşleşmeyen Personel",
                icon: "group_off",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Eşleşmeyen Personel",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/NotAssignedEmployee",
            name: "not-assigned-employee",
            component: () => import("@/views/employee-operations/not-assigned-employee/NotAssignedEmployeeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_GARAGE_OR_BRANCH_NOT_ASSIGNED_DATA_VIEW"],
                pageTitle: "Atanmayan Personel",
                icon: "person_add_disabled",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Atanmayan Personel",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/EmployeeOperations/Excuse',
        //   name: 'excuse',
        //   component: () => import('@/views/employee-operations/excuse/ExcuseView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["EMPLOYEE_EXCUSE_PROCESS"],
        //     pageTitle: 'İzin Takvimi',
        //     icon: 'event',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İzin',
        //         active: true,
        //       },
        //       {
        //         text: 'İzin Takvimi',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/EmployeeOperations/ExcuseGantt",
            name: "excuse-gantt",
            component: () => import("@/views/employee-operations/excuse/ExcuseGanttView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_EXCUSE_PROCESS"],
                pageTitle: "İzinler",
                icon: "event",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "İzin",
                        active: true,
                    },
                    {
                        text: "İzinler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/ExcuseGanttHourly",
            name: "excuse-gantt-hourly",
            component: () => import("@/views/employee-operations/excuse/ExcuseGanttHourlyView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_EXCUSE_PROCESS"],
                pageTitle: "Saatlik İzinler",
                icon: "alarm",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "İzin",
                        active: true,
                    },
                    {
                        text: "Saatlik İzinler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Excuse/Annual",
            name: "excuse-annual",
            component: () => import("@/views/employee-operations/excuse-annual/ExcuseAnnualView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_EXCUSE_PROCESS"],
                pageTitle: "Yıllık İzin",
                icon: "beach_access",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "İzin",
                        active: true,
                    },
                    {
                        text: "Yıllık İzin",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/ExcuseWaitingDocument",
            name: "excuse-waiting-document",
            component: () => import("@/views/employee-operations/excuse-waiting-document/ExcuseWaitingDocument.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_DOCUMENT_EXCUSE_PROCESS"],
                pageTitle: "Belge Bekleyen İzinler",
                icon: "document_scanner",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "İzin",
                        active: true,
                    },
                    {
                        text: "Belge Bekleyen İzinler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/GarageSalary",
            name: "garage-salary",
            component: () => import("@/views/employee-operations/garage-salary/GarageSalaryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_GARAGE_SALARY_OPERATIONS"],
                pageTitle: "Uygulanan Maaş (Garaj)",
                icon: "point_of_sale",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş Faktörleri",
                        active: true,
                    },
                    {
                        text: "Uygulanan Maaş (Garaj)",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/EmployeeOperations/Form',
        //   name: 'form',
        //   component: () => import('@/views/employee-operations/form-creator/FormView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     // requiresRole:["EMPLOYEE_GARAGE_SALARY_OPERATIONS"], todo
        //     pageTitle: 'Form',
        //     icon: 'fact_check',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Form',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        {
            path: "/EmployeeOperations/FormCreateOrUpdate/:id",
            name: "form-creator",
            component: () => import("@/views/employee-operations/form-creator/FormCreateOrUpdateView.vue"),
            meta: {
                requiresAuth: true,
                // requiresRole:["EMPLOYEE_GARAGE_SALARY_OPERATIONS"], todo
                pageTitle: "Form Oluşturucu",
                icon: "fact_check",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Form Oluşturucu",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/EmployeeOperations/DailyScore',
        //   name: 'daily-score',
        //   component: () => import('@/views/employee-operations/daily-score/DailyScoreView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["EMPLOYEE_DAILY_SCORE"],
        //     pageTitle: 'Günlük',
        //     icon: 'scoreboard',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Puantaj',
        //         active: true,
        //       },
        //       {
        //         text: 'Günlük',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/EmployeeOperations/DailyScoreByDate",
            name: "daily-score-by-date",
            component: () => import("@/views/employee-operations/daily-score-by-date/DailyScoreByDateView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_DAILY_SCORE"],
                pageTitle: "Günlük",
                icon: "scoreboard",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Puantaj",
                        active: true,
                    },
                    {
                        text: "Günlük",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/GarageSalaryMultiple",
            name: "garage-salary-multiple",
            component: () => import("@/views/employee-operations/garage-salary-multi/GarageSalaryMultiView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Toplu Maaş Güncelleme",
                icon: "view_headline",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş",
                        active: true,
                    },
                    {
                        text: "Toplu Maaş Güncelleme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/MonthlyScore",
            name: "monthly-score",
            component: () => import("@/views/employee-operations/monthly-score/MonthlyScoreView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Sürücü Maaşa Esas Aylık",
                icon: "sports_score",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Puantaj",
                        active: true,
                    },
                    {
                        text: "Sürücü Maaşa Esas Aylık",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/CalculateSalaryProcess",
            name: "calculate-salary-process",
            component: () => import("@/views/employee-operations/calculate-salary-process/CalculateSalaryProcessView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Banka 1",
                icon: "account_tree",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Banka 1",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/ExceptedRSalaryPayment",
            name: "excepted-r-salary-payment",
            component: () => import("@/views/employee-operations/excepted-r-salary-payment/ExceptedRSalaryPaymentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Ertelenen Banka 1 Maaş Ödemeleri",
                icon: "payments",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Ertelenen Banka 1 Maaş Ödemeleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/SalaryLock",
            name: "salary-lock",
            component: () => import("@/views/employee-operations/salary-lock/SalaryLockView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Banka 1 Maaş Kilit",
                icon: "lock",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Banka 1 Maaş Kilit",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/GSalaryLock",
            name: "g-salary-lock",
            component: () => import("@/views/employee-operations/g-salary-lock/GSalaryLockView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Banka 2 Maaş Kilit",
                icon: "lock",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Banka 2 Maaş Kilit",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/GCalculateSalaryProcess",
            name: "calculate-salary-process-g",
            component: () => import("@/views/employee-operations/calculate-salary-process-g/CalculateSalaryProcessGView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Banka 2",
                icon: "account_tree",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Banka 2",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/DomesticDriverSalary",
            name: "domestic-driver-salary",
            component: () => import("@/views/employee-operations/domestic-driver-salary/DomesticDriverSalaryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Yurt İçi Sürücü Maaşı",
                icon: "local_shipping",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Yurt İçi Sürücü Maaşı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/ManAllowanceUpload",
            name: "man-allowance-upload",
            component: () => import("@/views/employee-operations/man-allowance-upload/ManAllowanceUploadView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Ek Hakediş Yükleme",
                icon: "upload_file",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Ek Hakediş Yükleme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/EkHakedisReport",
            name: "ek-hakedis-report",
            component: () => import("@/views/reports/ek-hakedis-report/EkHakedisReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EK_HAKEDIS_REPORT_VIEW"],
                pageTitle: "Ek Hakediş Raporu",
                icon: "restaurant",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Ek Hakediş Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/MaasBilgileriReport",
            name: "maas-bilgileri-report",
            component: () => import("@/views/reports/maas-bilgileri-report/MaasBilgileriReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["MAAS_BILGILERI_REPORT_VIEW"],
                pageTitle: "Maaş Bilgileri Raporu",
                icon: "payments",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Maaş Bilgileri Raporu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/KasaDekont",
            name: "kasa-dekont",
            component: () => import("@/views/employee-operations/kasa-dekont/KasaDekontView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SALARY_OPERATIONS"],
                pageTitle: "Kasa Dekont",
                icon: "receipt_long",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Kasa Dekont",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/FM",
            name: "fm",
            component: () => import("@/views/employee-operations/fm/FMView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Fazla Mesai",
                icon: "edit_calendar",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş Faktörleri",
                        active: true,
                    },
                    {
                        text: "Fazla Mesai",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/LucaComparation",
            name: "luca-comparation",
            component: () => import("@/views/employee-operations/luca-comparation/LucaComparationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Luca Karşılaştırma",
                icon: "difference",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Luca Karşılaştırma",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/NotDriverMonthlyScore",
            name: "not-driver-monthly-score",
            component: () => import("@/views/employee-operations/not-driver-monthly-score/NotDriverMonthlyScoreView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "İdari Maaşa Esas Aylık",
                icon: "sports_score",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Puantaj",
                        active: true,
                    },
                    {
                        text: "İdari Maaşa Esas Aylık",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TrafficFine",
            name: "traffic-fine",
            component: () => import("@/views/employee-operations/traffic-fine/TrafficFineView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TRAFFIC_FINE_PROCESS"],
                pageTitle: "Trafik Cezaları",
                icon: "directions",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş Faktörleri",
                        active: true,
                    },
                    {
                        text: "Trafik Cezaları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Levy",
            name: "levy",
            component: () => import("@/views/employee-operations/levy/LevyView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["LEVY_PROCESS"],
                pageTitle: "İcralar",
                icon: "card_travel",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş Faktörleri",
                        active: true,
                    },
                    {
                        text: "İcralar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/DriverExcuse",
            name: "driver-excuse",
            component: () => import("@/views/employee-operations/driver-excuse/DriverExcuseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ADMIN_DRIVER_JOB_EXIT_VALUE"],
                pageTitle: "Sürücü İzin",
                icon: "schedule",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Sürücü İzin",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/DailyScoreTracing",
            name: "daily-score-tracing",
            component: () => import("@/views/employee-operations/daily-score-tracing/DailyScoreTracingView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_DAILY_SCORE_TRACING"],
                pageTitle: "Sürücü Günlük Takip",
                icon: "analytics",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Puantaj",
                        active: true,
                    },
                    {
                        text: "Sürücü Günlük Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/NotDriverDailyScoreTracing",
            name: "not-dirver-daily-score-tracing",
            component: () => import("@/views/employee-operations/not-driver-daily-score-tracing/NotDriverDailyScoreTracingView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_DAILY_SCORE_TRACING"],
                pageTitle: "İdari Günlük Takip",
                icon: "analytics",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Puantaj",
                        active: true,
                    },
                    {
                        text: "İdari Günlük Takip",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/DailyScoreEdit",
            name: "daily-score-edit",
            component: () => import("@/views/employee-operations/daily-score-edit/DailyScoreEditView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_DAILY_SCORE_TRACING_EDIT"],
                pageTitle: "Günlük Düzenleme",
                icon: "analytics",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Puantaj",
                        active: true,
                    },
                    {
                        text: "Günlük Düzenleme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/BranchHumanResourcesAssign",
            name: "branch-human-resources-assign",
            component: () => import("@/views/employee-operations/branch-human-resources-assign/BranchHumanResourcesAssignView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["BRANCH_HUMANRESOURCE_ASSIGN_OPERATIONS"],
                pageTitle: "Şube İnsan Kaynakları Sorumlusu",
                icon: "assignment_ind",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Şube İnsan Kaynakları Sorumlusu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/AdvancePayment",
            name: "advance-payment",
            component: () => import("@/views/employee-operations/advance-payment/AdvancePaymentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_EFFECT_PAYMENT_PROCESS"],
                pageTitle: "KYKM Ödemeleri",
                icon: "payments",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "KYKM",
                        active: true,
                    },
                    {
                        text: "Ödemeler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/OldExitCompletion",
            name: "old-exit-completion",
            component: () => import("@/views/employee-operations/old-exit-completion/OldExitCompletionView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["OLD_EXIT_COMPLETION"],
                pageTitle: "Eski Çıkış Kayıtları Düzenleme",
                icon: "edit_note",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Eski Çıkış Kayıtları Düzenleme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Mediation",
            name: "mediation",
            component: () => import("@/views/employee-operations/mediation/MediationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["MEDIATION_PROCESS"],
                pageTitle: "Arabuluculuk",
                icon: "handshake",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Arabuluculuk",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/AdvancePaymentGroupKey",
            name: "advance-payment-group-key",
            component: () => import("@/views/employee-operations/advance-payment-group-key/AdvancePaymentGroupKeyTabView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_EFFECT_PAYMENT_PROCESS"],
                pageTitle: "Banka Dosyası Kimlikleri",
                icon: "price_check",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Ödeme",
                        active: true,
                    },
                    {
                        text: "Banka Dosyası Kimlikleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/SalaryGroup",
            name: "salary-group",
            component: () => import("@/views/employee-operations/salary-group/SalaryGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_EFFECT_PAYMENT_PROCESS"],
                pageTitle: "Gruplar",
                icon: "price_check",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Ödeme",
                        active: true,
                    },
                    {
                        text: "Gruplar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/AdvancePaymentRules",
            name: "advance-payment-rules",
            component: () => import("@/views/employee-operations/advance-payment-rules/AdvancePaymentRulesView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_EFFECT_PAYMENT_PROCESS"],
                pageTitle: "KYKM Atama Kuralları",
                icon: "gavel",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "KYKM",
                        active: true,
                    },
                    {
                        text: "Atama Kuralları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/AdvancePaymentAssign",
            name: "advance-payment-assign",
            component: () => import("@/views/employee-operations/advance-payment/AdvancePaymentAssignView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_EFFECT_PAYMENT_PROCESS"],
                pageTitle: "KYKM Ödemesi Atama",
                icon: "payments",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "KYKM",
                        active: true,
                    },
                    {
                        text: "Ödemeler",
                        active: false,
                        to: "/EmployeeOperations/AdvancePayment",
                    },
                    {
                        text: "Atama",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/EmployeeOperations/Crash',
        //   name: 'crash',
        //   component: () => import('@/views/employee-operations/crash/CrashView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["CRASH_OPERATIONS"],
        //     pageTitle: 'Kaza',
        //     icon: 'car_crash',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Maaş Faktörleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Kaza',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/EmployeeOperations/Incident",
            name: "incident",
            component: () => import("@/views/employee-operations/incident/IncidentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["INCIDENT"],
                pageTitle: "Vukuat",
                icon: "report",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş Faktörleri",
                        active: true,
                    },
                    {
                        text: "Vukuat",
                        active: true,
                    },
                ],
            },
        },
        // {
        //     path: "/EmployeeOperations/Incident/CaseCategory",
        //     name: "incident-case-category",
        //     component: () => import("@/views/employee-operations/incident/CaseCategoryView.vue"),
        //     meta: {
        //         requiresAuth: true,
        //         requiresRole: ["INCIDENT"],
        //         pageTitle: "Vukuat Kayıt Parametre Kategorisi",
        //         icon: "category",
        //         breadcrumb: [
        //             {
        //                 text: "Personel İşlemleri",
        //                 active: true,
        //             },
        //             {
        //                 text: "Kayıt Parametre Kategorisi",
        //                 active: true,
        //             },
        //         ],
        //     },
        // },
        {
            path: "/EmployeeOperations/Incident/Tree",
            name: "incident-case-tree",
            component: () => import("@/views/employee-operations/incident/CaseTreeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["INCIDENT"],
                pageTitle: "Vukuat Parametreleri",
                icon: "category",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Vukuat Kayıt",
                        active: true,
                    },
                ],
            },
        },
        // {
        //     path: "/EmployeeOperations/Incident/CaseType",
        //     name: "incident-case-type",
        //     component: () => import("@/views/employee-operations/incident/CaseTypeView.vue"),
        //     meta: {
        //         requiresAuth: true,
        //         requiresRole: ["INCIDENT"],
        //         pageTitle: "Vukuat Kayıt Parametre Tipi",
        //         icon: "label",
        //         breadcrumb: [
        //             {
        //                 text: "Personel İşlemleri",
        //                 active: true,
        //             },
        //             {
        //                 text: "Kayıt Parametre Tipi",
        //                 active: true,
        //             },
        //         ],
        //     },
        // },
        {
            path: "/EmployeeOperations/Incident/ApprovalConfiguration",
            name: "incident-approval-configuration",
            component: () => import("@/views/employee-operations/incident/ApprovalConfiguration.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["INCIDENT"],
                pageTitle: "Vukuat Onay Kuralları",
                icon: "rule",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Vukuat",
                        to: "/EmployeeOperations/Incident",
                        active: false,
                    },
                    {
                        text: "Onay Kuralları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TrafficFine/ApprovalConfiguration",
            name: "traffic-fine-approval-configuration",
            component: () => import("@/views/employee-operations/traffic-fine/ApprovalConfiguration.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["TRAFFIC_FINE_PROCESS"],
                pageTitle: "Trafik Cezası Onay Kuralları",
                icon: "rule",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Trafik Cezaları",
                        to: "/EmployeeOperations/TrafficFine",
                        active: false,
                    },
                    {
                        text: "Onay Kuralları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Incident/My-Approvals",
            name: "incident-my-approvals",
            component: () => import("@/views/employee-operations/incident/MyIncidentApprovals.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ONAYIMI_BEKLEYEN_VUKUATLARI_GORUNTULEME"],
                pageTitle: "Onayımı Bekleyen Vukuatlar",
                icon: "av_timer",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Onayımdaki Vukuatlar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TrafficFine/My-Approvals",
            name: "traffic-fine-my-approvals",
            component: () => import("@/views/employee-operations/traffic-fine/MyTrafficFineApprovals.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ONAYIMI_BEKLEYEN_TRAFIK_CEZALARINI_GORUNTULEME"],
                pageTitle: "Onayımı Bekleyen Trafik Cezaları",
                icon: "av_timer",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Onayımdaki Trafik Cezaları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/Salary",
            name: "employee-salary",
            component: () => import("@/views/employee-operations/salary/SalaryView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_OPERATIONS"],
                pageTitle: "Son Maaş Tablosu",
                icon: "payments",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Son Maaş Tablosu",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Reports/MediationReport",
            name: "mediation-report",
            component: () => import("@/views/reports/mediation/MediationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Arabuluculuk Raporu",
                icon: "handshake",
                breadcrumb: [
                    {
                        text: "Raporlar",
                        active: true,
                    },
                    {
                        text: "Personel",
                        active: true,
                    },
                    {
                        text: "Arabuluculuk Raporu",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/EmployeeOperations/GSalary',
        //   name: 'employee-g-salary',
        //   component: () => import('@/views/employee-operations/g-salary/GSalaryView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["SALARY_OPERATIONS"],
        //     pageTitle: 'G Maaş',
        //     icon: 'table_rows',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'G Maaş',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        // {
        //   path: '/EmployeeOperations/GSalaryUpload',
        //   name: 'employee-g-salary-upload',
        //   component: () => import('@/views/employee-operations/g-salary-upload/GSalaryUploadView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["SALARY_OPERATIONS"],
        //     pageTitle: 'G Maaş Yükleme',
        //     icon: 'table_rows',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'G Maaş Yükleme',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/EmployeeOperations/Salary/Payment",
            name: "employee-salary-payment",
            component: () => import("@/views/employee-operations/salary-payment/SalaryPaymentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_OPERATIONS"],
                pageTitle: "Maaş Ödemesi",
                icon: "payments",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Maaş Ödemesi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/BES",
            name: "employee-bes",
            component: () => import("@/views/employee-operations/bes/BesView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["BES_OPERATIONS"],
                pageTitle: "BES",
                icon: "elderly",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "BES",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/SGKExitMyApprovals",
            name: "employee-sgk-exit-my-approvals",
            component: () => import("@/views/employee-operations/sgk-exit-my-approvals/SGKExitMyApprovalsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_LIST"],
                pageTitle: "Onayımı Bekleyen Çıkışlar",
                icon: "av_timer",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Onayımı Bekleyen Çıkışlar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/SGKExitOTT/:q",
            name: "employee-sgk-exit-ott",
            component: () => import("@/views/employee-operations/sgk-exit-ott/SGKExitOttView.vue"),
            meta: {
                layout: "full",
                //requiresAuth: true,
                //requiresRole: ["EMPLOYEE_LIST"],
                public: true,
                pageTitle: "Onayımı Bekleyen Çıkış",
                icon: "av_timer",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Onayımı Bekleyen Çıkış",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/IncidentOTT/:q",
            name: "incident-ott-view",
            component: () => import("@/views/employee-operations/incident/IncidentOttView.vue"),
            meta: {
                layout: "full",
                public: true,
                pageTitle: "Onayımı Bekleyen Vukuat",
                icon: "av_timer",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Onayımı Bekleyen Vukuat",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/EmployeeOperations/TrafficFineOTT/:q",
            name: "traffic-fine-ott-view",
            component: () => import("@/views/employee-operations/traffic-fine/TrafficFineOttView.vue"),
            meta: {
                layout: "full",
                public: true,
                pageTitle: "Onayımı Bekleyen Trafik Cezası",
                icon: "av_timer",
                breadcrumb: [
                    {
                        text: "Personel İşlemleri",
                        active: true,
                    },
                    {
                        text: "Onayımı Bekleyen Trafik Cezası",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/EmployeeOperations/Ticket',
        //   name: 'employee-ticket',
        //   component: () => import('@/views/employee-operations/ticket/TicketView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["TICKET_OPERATIONS"],
        //     pageTitle: 'Ticket',
        //     icon: 'restaurant',
        //     breadcrumb: [
        //       {
        //         text: 'Personel İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Ticket',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        // {
        //   path: '/HumanResourcesParameters/ExpenseLocation',
        //   name: 'hr-expense-location',
        //   component: () => import('@/views/human-resources-parameters/expense-location/ExpenseLocationView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["HR_PARAMS_EXPENSE_LOCATION_LIST"],
        //     pageTitle: 'Maliyet Merkezi',
        //     icon: 'local_atm',
        //     breadcrumb: [
        //       {
        //         text: 'Sistem Parametreleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İnsan Kaynakları',
        //         active: true,
        //       },
        //       {
        //         text: 'Maliyet Merkezi',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/HumanResourcesParameters/TaskArea",
            name: "hr-task-area",
            component: () => import("@/views/human-resources-parameters/task-area/TaskAreaView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_TASK_AREA_LIST"],
                pageTitle: "Görev Yeri",
                icon: "person_pin_circle",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Görev Yeri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/SizeInformation",
            name: "hr-size-information",
            component: () => import("@/views/human-resources-parameters/size-information/SizeInformationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_SIZE_INFORMATION_LIST"],
                pageTitle: "Beden Bilgileri",
                icon: "straighten",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Beden Bilgileri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/SizeInformationParameter",
            name: "hr-size-information-parameters",
            component: () => import("@/views/human-resources-parameters/size-information-parameters/SizeInformationParameterView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_SIZE_INFORMATION_PARAMS_LIST"],
                pageTitle: "Beden Değerleri",
                icon: "square_foot",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Beden Değerleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/KYKM",
            name: "hr-kykm",
            component: () => import("@/views/human-resources-parameters/kykm/KYKMView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_BANK_LIST"],
                pageTitle: "KYKM",
                icon: "paid",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "KYKM",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/HumanResourcesParameters/Bank',
        //   name: 'hr-bank',
        //   component: () => import('@/views/human-resources-parameters/bank/BankView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["HR_PARAMS_BANK_LIST"],
        //     pageTitle: 'Banka',
        //     icon: 'account_balance',
        //     breadcrumb: [
        //       {
        //         text: 'Sistem Parametreleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İnsan Kaynakları',
        //         active: true,
        //       },
        //       {
        //         text: 'Banka',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        // {
        //   path: '/HumanResourcesParameters/BankBranch',
        //   name: 'hr-bank-branch',
        //   component: () => import('@/views/human-resources-parameters/bank-branch/BankBranchView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["HR_PARAMS_BANK_BRANCH_LIST"],
        //     pageTitle: 'Banka Şubeleri',
        //     icon: 'foundation',
        //     breadcrumb: [
        //       {
        //         text: 'Sistem Parametreleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İnsan Kaynakları',
        //         active: true,
        //       },
        //       {
        //         text: 'Banka Şubeleri',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/HumanResourcesParameters/EmployeeProficiency",
            name: "hr-employee-proficiency",
            component: () => import("@/views/human-resources-parameters/employee-proficiency/EmployeeProficiencyView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_EMPLOYEE_PROFICENCY_LIST"],
                pageTitle: "Çalışan Yetkinliği",
                icon: "sign_language",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Çalışan Yetkinliği",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/EmployeeProficiencyParameters",
            name: "hr-employee-proficiency-parameters",
            component: () => import("@/views/human-resources-parameters/employee-proficiency-parameters/EmployeeProficiencyParameterView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_EMPLOYEE_PROFICENCY_PARAMS_LIST"],
                pageTitle: "Çalışan Yetkinliği Parametreleri",
                icon: "waving_hand",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Çalışan Yetkinliği Parametreleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/Branch",
            name: "hr-branch",
            component: () => import("@/views/human-resources-parameters/branch/BranchView.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: "Şube",
                requiresRole: ["HR_PARAMS_BRANCH_LIST"],
                icon: "apartment",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Şube",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/SGKExitApprovalLevel",
            name: "hr-sgk-exit-approval",
            component: () => import("@/views/human-resources-parameters/sgk-exit-approval/SGKExitApprovalView.vue"),
            meta: {
                requiresAuth: true,
                pageTitle: "İşten Çıkış Onay Seviyeleri",
                requiresRole: ["HR_PARAMS_BRANCH_LIST"],
                icon: "schema",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "İşten Çıkış Onay Seviyeleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/Department",
            name: "hr-employee-department",
            component: () => import("@/views/human-resources-parameters/employee-department/EmployeeDepartmentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_PARAMS_DEPARTMENT_LIST", "HR_PARAMS_DEPARTMENT_TITLES_LIST"],
                pageTitle: "Bölüm ve Bölüm Unvanı",
                icon: "business",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Bölüm ve Bölüm Unvanı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/PersonalProtectiveEquipment",
            name: "hr-personal-protective-equipment",
            component: () => import("@/views/human-resources-parameters/personal-protective-equipment/PersonalProtectiveEquipmentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["PERSONAL_PROTECTIVE_EQUIPMENT"],
                pageTitle: "Kişisel Koruyucu Donanımlar",
                icon: "home_repair_service",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Kişisel Koruyucu Donanımlar",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/SalaryEffectType",
            name: "hr-salary-effect-type",
            component: () => import("@/views/human-resources-parameters/salary-effect-type/SalaryEffectTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["SALARY_INPUT_TYPES"],
                pageTitle: "KYKM Türleri",
                icon: "paid",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "KYKM Türleri",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/HumanResourcesParameters/SalaryEffectTypeGroup',
        //   name: 'hr-salary-effect-type-group',
        //   component: () => import('@/views/human-resources-parameters/salary-effect-type-group/SalaryEffectTypeGroupView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["SALARY_INPUT_TYPE_GROUP"],
        //     pageTitle: 'KYKM Tür Grupları',
        //     icon: 'paid',
        //     breadcrumb: [
        //       {
        //         text: 'Sistem Parametreleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İnsan Kaynakları',
        //         active: true,
        //       },
        //       {
        //         text: 'KYKM Tür Grupları',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/HumanResourcesParameters/ExcuseType",
            name: "hr-excuse-type",
            component: () => import("@/views/human-resources-parameters/excuse-type/ExcuseTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_EXCUSE_TYPE"],
                pageTitle: "İzin Türleri",
                icon: "fact_check",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "İzin Türleri",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/HumanResourcesParameters/NetsisAccountCode',
        //   name: 'hr-netsis-account-code',
        //   component: () => import('@/views/human-resources-parameters/netsis-account-code/NetsisAccountCodeView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     // requiresRole:["EMPLOYEE_EXCUSE_PROCESS_TYPE"],
        //     pageTitle: 'Netsis Hesap Kodu',
        //     icon: 'supervised_user_circle',
        //     breadcrumb: [
        //       {
        //         text: 'Sistem Parametreleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İnsan Kaynakları',
        //         active: true,
        //       },
        //       {
        //         text: 'Netsis Hesap Kodu',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/HumanResourcesParameters/BonusPaymentType",
            name: "hr-bonus-payment-type",
            component: () => import("@/views/human-resources-parameters/bonus-payment-type/BonusPaymentTypeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["BONUS_PAYMENT_TYPE_OPERATIONS"],
                pageTitle: "Prim Türü",
                icon: "savings",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Prim Türü",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/JobExitCause",
            name: "hr-job-exit-cause",
            component: () => import("@/views/human-resources-parameters/job-exit-cause/JobExitCauseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_EXIT_CAUSE_TYPE"],
                pageTitle: "İşten Çıkış Sebebi Türü",
                icon: "savings",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "İşten Çıkış Sebebi Türü",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/JobExitSpecialCause",
            name: "hr-job-exit-special-cause",
            component: () => import("@/views/human-resources-parameters/job-exit-special-cause/JobExitSpecialCauseView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_JOB_EXIT_SPECIAL_CAUSE"],
                pageTitle: "İşten Çıkış Özel Sebebi",
                icon: "savings",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "İşten Çıkış Özel Sebebi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/ShiftTime",
            name: "hr-shift-time",
            component: () => import("@/views/human-resources-parameters/shift-time/ShiftTimeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["EMPLOYEE_SHIFT_TIME"],
                pageTitle: "Mesai Saatleri",
                icon: "update",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Mesai Saatleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/BrutOperations",
            name: "hr-brut-calculate",
            component: () => import("@/views/human-resources-parameters/brut/BrutOperationsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_BRUT_OPERATIONS"],
                pageTitle: "Brüt Hesaplama Parametreleri",
                icon: "add_task",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Brüt Hesaplama Parametreleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/IncidentReason",
            name: "hr-incident-reason",
            component: () => import("@/views/human-resources-parameters/incident-reason/IncidentReasonView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_INCIDENT_REASON"],
                pageTitle: "Vukuat Türü",
                icon: "crisis_alert",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Vukuat Türü",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/FaultTypeGroup",
            name: "hr-fault-type-group",
            component: () => import("@/views/human-resources-parameters/fault-type-group/FaultTypeGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_INCIDENT_REASON"],
                pageTitle: "Arıza Tipi Ana Grubu",
                icon: "disc_full",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Arıza Tipi Ana Grubu",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/HumanResourcesParameters/EksikGun',
        //   name: 'hr-eksik-gun',
        //   component: () => import('@/views/human-resources-parameters/eksik-gun/EksikGunView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     //requiresRole:["HR_INCIDENT_REASON"], todo
        //     pageTitle: 'Eksik Gün',
        //     icon: 'free_cancellation',
        //     breadcrumb: [
        //       {
        //         text: 'Sistem Parametreleri',
        //         active: true,
        //       },
        //       {
        //         text: 'İnsan Kaynakları',
        //         active: true,
        //       },
        //       {
        //         text: 'Eksik Gün',
        //         active: true,
        //       }
        //     ],
        //   },
        // },
        {
            path: "/HumanResourcesParameters/LucaDayCode",
            name: "hr-luca-day-code",
            component: () => import("@/views/human-resources-parameters/luca-day-code/LucaDayCodeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_INCIDENT_REASON"],
                pageTitle: "Luca Gün Kodları",
                icon: "merge_type",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Luca Gün Kodları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/SGKEksikGun",
            name: "hr-sgk-eksik-gun",
            component: () => import("@/views/human-resources-parameters/sgk-eksik-gun/SGKEksikGunView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_INCIDENT_REASON"],
                pageTitle: "SGK Eksik Gün",
                icon: "free_cancellation",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "SGK Eksik Gün",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/PublicHoliday",
            name: "hr-public-holiday",
            component: () => import("@/views/human-resources-parameters/public-holiday/PublicHolidayView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "Resmi Tatiller",
                icon: "beach_access",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Resmi Tatiller",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/AdministrativeLevelGroup",
            name: "administrative-level-group",
            component: () => import("@/views/human-resources-parameters/administrative-level-group/AdministrativeLevelGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "Yönetsel Düzey Grupları",
                icon: "nature",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Yönetsel Düzey Grupları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/AdministrativeLevel",
            name: "administrative-level",
            component: () => import("@/views/human-resources-parameters/administrative-level/AdministrativeLevelView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "Yönetsel Düzeyler",
                icon: "lan",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Yönetsel Düzeyler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/HealtReportSurvellianceReason",
            name: "health-report-surveillance-reason",
            component: () => import("@/views/human-resources-parameters/health-report-surveillance-reason/HealthReportSurveillanceReasonView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "Sağlık Raporu Takip Gerekçesi",
                icon: "monitor_heart",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Sağlık Raporu Takip Gerekçesi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/HazardClass",
            name: "hazard-class",
            component: () => import("@/views/human-resources-parameters/hazard-class/HazardClassView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "Tehlike Sınıfı",
                icon: "report_gmailerrorred",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "Tehlike Sınıfı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/OHSEducation",
            name: "ohs-education",
            component: () => import("@/views/human-resources-parameters/ohs-education/OHSEducationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "İSG Eğitimi",
                icon: "school",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "İSG Eğitimi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/HumanResourcesParameters/SRCType",
            name: "src-types",
            component: () => import("@/views/human-resources-parameters/src-o/SRCView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["HR_SYSTEM_PARAMETERS"],
                pageTitle: "SRC Belge Türleri",
                icon: "sports_motorsports",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "İnsan Kaynakları",
                        active: true,
                    },
                    {
                        text: "SRC Belge Türleri",
                        active: true,
                    },
                ],
            },
        },
        /**{
                    title:"Brüt Hesaplama Parametreleri",
                    route:'hr-brut-calculate',
                    icon:'add_task'
                } */
        {
            path: "/MaintenanceOperations/MainGroup",
            name: "maintenance-main-group",
            component: () => import("@/views/maintenance-operations/main-group/MainGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["MAINTENANCE_MAIN_GROUP_LIST"],
                icon: "group_work",
                pageTitle: "Ana Grup",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Bakım Onarım",
                        active: true,
                    },
                    {
                        text: "Ana Grup",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/MaintenanceOperations/SubGroup",
            name: "maintenance-sub-group",
            component: () => import("@/views/maintenance-operations/sub-group/SubGroupView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["MAINTENANCE_SUB_GROUP_LIST"],
                icon: "category",
                pageTitle: "Alt Grup",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Bakım Onarım",
                        active: true,
                    },
                    {
                        text: "Alt Grup",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/MaintenanceOperations/PartOf",
            name: "maintenance-part-of",
            component: () => import("@/views/maintenance-operations/part-of/PartOfView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["MAINTENANCE_PART_LIST"],
                icon: "webhook",
                pageTitle: "Parça",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Bakım Onarım",
                        active: true,
                    },
                    {
                        text: "Parça",
                        active: true,
                    },
                ],
            },
        },
        /** VAULT */
        // {
        //   path: '/VaultOperations/Vault',
        //   name: 'vault',
        //   component: () => import('@/views/vault-operations/vault/VaultView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["VAULT_PROCESS"],
        //     icon: 'account_balance_wallet',
        //     pageTitle: 'Kasa',
        //     breadcrumb: [
        //       {
        //         text: 'Kasa İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Kasa',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        {
            path: "/VaultOperations/MuhasebeHesapPlani",
            name: "vault-muhasebe-plani",
            component: () => import("@/views/vault-operations/muhasebe-hesap-plani/MuhasebeHesapPlaniView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "account_tree",
                pageTitle: "Muhasebe Hesap Planı",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Muhasebe Hesap Planı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/TrafikCezasiHesapPlani",
            name: "vault-trafik-cezasi-plani",
            component: () => import("@/views/vault-operations/trafik-cezasi-hesap-plani/TrafikCezasiHesapPlaniView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "account_tree",
                pageTitle: "Trafik Cezası Hesap Planı",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Trafik Cezası Hesap Planı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/Cari",
            name: "caris",
            component: () => import("@/views/vault-operations/cari/CariView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "social_distance",
                pageTitle: "Cariler",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Cariler",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/Report",
            name: "vault-report",
            component: () => import("@/views/vault-operations/vault-report/VaultReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                pageTitle: "Kasa Raporu",
                icon: "assessment",
                breadcrumb: [{ text: "Kasa İşlemleri" }, { text: "Kasa Raporu", active: true }],
            },
        },
        {
            path: "/VaultOperations/EmployeeBalance",
            name: "employee-balance",
            component: () => import("@/views/vault-operations/employee-balance/EmployeeBalanceView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "currency_exchange",
                pageTitle: "Personel Yıllık Cari Hesap",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Personel Yıllık Cari Hesap",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/Cari/Detay/:code",
            name: "cari-detail",
            component: () => import("@/views/vault-operations/cari/CariDetailView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "social_distance",
                pageTitle: "Cari Detay",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Cariler",
                        active: false,
                        to: "/VaultOperations/Cari",
                    },
                    {
                        text: "Cari Detay",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/RaporKodu",
            name: "vault-report-code",
            component: () => import("@/views/vault-operations/report-code/ReportCodeView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "ssid_chart",
                pageTitle: "Kasa Rapor Kodu",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Kasa Rapor Kodu",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/VaultOperations/Lock',
        //   name: 'vault-lock',
        //   component: () => import('@/views/vault-operations/vault-lock/VaultLockView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole:["VAULT_PROCESS"],
        //     icon: 'lock',
        //     pageTitle: 'Kasa Kilitleme',
        //     breadcrumb: [
        //       {
        //         text: 'Kasa İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Kasa Kilitleme',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        {
            path: "/VaultOperations/Lock",
            name: "vault-lock",
            component: () => import("@/views/vault-operations/vault-lock-month/VaultLockMonthView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "lock",
                pageTitle: "Kasa Kilitleme",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Kasa Kilitleme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/Banka2Avans",
            name: "banka-2-avans",
            component: () => import("@/views/vault-operations/banka-2-avans/Banka2AvansView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "payments",
                pageTitle: "Banka 2 Avans",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Banka 2 Avans",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/BankaHesapPlani",
            name: "vault-banka-plani",
            component: () => import("@/views/vault-operations/banka-hesap-plani/BankaHesapPlaniView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "account_tree",
                pageTitle: "Banka Hesap Planı",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Banka Hesap Planı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/BelgeTuru",
            name: "vault-belge-turu",
            component: () => import("@/views/vault-operations/belge-turu/BelgeTuruView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "file_copy",
                pageTitle: "Belge Türü",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Belge Türü",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/AccountPair",
            name: "vault-account-pair",
            component: () => import("@/views/vault-operations/account-pair/AccountPairView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "earbuds",
                pageTitle: "Hesap Eşleşmesi",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Hesap Eşleşmesi",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/KasaHesapPlani",
            name: "vault-kasa-hesap-plani",
            component: () => import("@/views/vault-operations/kasa-hesap-plani/KasaHesapPlaniView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "account_tree",
                pageTitle: "Netsis Kasa Hesap Planı",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: " NetsisKasa Hesap Planı",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/UserOfNetsisVault",
            name: "user-of-netsis-vault",
            component: () => import("@/views/vault-operations/user-of-netsis-kasa/UserOfNetsisKasaView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_PROCESS"],
                icon: "admin_panel_settings",
                pageTitle: "Netsis Kasa Kullanıcıları",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa Kullanıcıları",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/EmployeePayment",
            name: "employee-payment",
            component: () => import("@/views/vault-operations/employee-payment/EmployeePaymentView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_EMPLOYEE_PAYMENT"],
                icon: "local_atm",
                pageTitle: "Personel Maaş Ödeme",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Personel Maaş Ödeme",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/VaultActions",
            name: "vault-actions",
            component: () => import("@/views/vault-operations/vault-actions/VaultActionsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NETSIS_VAULT_ACTIONS"],
                icon: "sync_alt",
                pageTitle: "Netsis Kasa Hareketleri",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa - Kasa Hareketleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/CariVaultAction",
            name: "cari-vault-action",
            component: () => import("@/views/vault-operations/vault-actions/cari/CariVaultActionView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NETSIS_CARI_VAULT_ACTION"],
                icon: "radio_button_checked",
                pageTitle: "Netsis Kasa - Cari İşlemleri",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa - Cari İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/BankVaultAction",
            name: "bank-vault-action",
            component: () => import("@/views/vault-operations/vault-actions/bank/BankVaultActionView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NETSIS_BANK_VAULT_ACTION"],
                icon: "account_balance",
                pageTitle: "Netsis Kasa - Banka İşlemleri",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa - Banka İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/MuhtelifVaultAction",
            name: "muhtelif-vault-action",
            component: () => import("@/views/vault-operations/vault-actions/muhtelif/MuhtelifVaultActionView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NETSIS_MUHTELIF_VAULT_ACTION"],
                icon: "shuffle",
                pageTitle: "Netsis Kasa - Muhtelif İşlemleri",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa - Muhtelif İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/TransferVaultAction",
            name: "transfer-vault-action",
            component: () => import("@/views/vault-operations/vault-actions/transfer/TransferVaultActionView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NETSIS_TRANSFER_VAULT_ACTION"],
                icon: "swap_horiz",
                pageTitle: "Netsis Kasa - Transfer İşlemleri",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa - Transfer İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/VaultOperations/Invoice",
            name: "invoice-vault-action",
            component: () => import("@/views/vault-operations/vault-actions/fatura/FaturaView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["NETSIS_TRANSFER_VAULT_ACTION"],
                icon: "request_quote",
                pageTitle: "Netsis Kasa - Fatura",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Netsis Kasa - Fatura",
                        active: true,
                    },
                ],
            },
        },
        // {
        //   path: '/VaultOperations/InvoiceOld',
        //   name: 'invoice-vault-action',
        //   component: () => import('@/views/vault-operations/vault-actions/fatura/FaturaViewold.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole: ["NETSIS_TRANSFER_VAULT_ACTION"],
        //     icon: 'request_quote',
        //     pageTitle: 'Netsis Kasa - Fatura',
        //     breadcrumb: [
        //       {
        //         text: 'Kasa İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Netsis Kasa İşlemleri',
        //         active: true,
        //       },
        //       {
        //         text: 'Netsis Kasa - Fatura',
        //         active: true,
        //       },
        //     ],
        //   },
        // },
        {
            path: "/VaultOperations/TrafficFine",
            name: "vault-traffic-fine",
            component: () => import("@/views/vault-operations/traffic-fine/TrafficFineView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["VAULT_TRAFFIC_FINE"],
                icon: "traffic",
                pageTitle: "Trafik Cezası Ödemeleri",
                breadcrumb: [
                    {
                        text: "Kasa İşlemleri",
                        active: true,
                    },
                    {
                        text: "Trafik Cezası Ödemeleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/CompanyBankAccount",
            name: "company-bank-account",
            component: () => import("@/views/company-bank-accounts/CompanyBankAccountsView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["COMPANY_BANK_ACCOUNT"],
                icon: "assured_workload",
                pageTitle: "Banka Hesapları",
                breadcrumb: [
                    {
                        text: "Sistem Parametreleri",
                        active: true,
                    },
                    {
                        text: "Banka Hesapları",
                        active: true,
                    },
                ],
            },
        },
        /** CUSTOMER  */
        {
            path: "/Customer/DraftOffer",
            name: "customer-draft-offer",
            component: () => import("@/views/customer/draft-offer/DraftOfferView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["CUSTOMER_DRAFT_OFFER_VIEW_UPDATE"],
                icon: "receipt_long",
                pageTitle: "Teklif İşlemleri",
                breadcrumb: [
                    {
                        text: "Teklif İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Customer/DraftOffer/Detail/:id",
            name: "customer-draft-offer-detail",
            component: () => import("@/views/customer/draft-offer/DraftOfferDetailView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["CUSTOMER_DRAFT_OFFER_VIEW_UPDATE"],
                icon: "receipt_long",
                pageTitle: "Teklif İşlemleri",
                breadcrumb: [
                    {
                        text: "Teklif İşlemleri",
                        active: true,
                    },
                ],
            },
        },
        {
            path: "/Admin/RegistryDocumentValue",
            name: "admin-registry-document-value",
            component: () => import("@/views/admin/registry-document-value/RegistryDocumentValueView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["ADMIN_REGISTRY_DOCUMENT_VALUE"],
                icon: "data_object",
                pageTitle: "Sicil Dosyası Değerleri",
                breadcrumb: [
                    {
                        text: "Sicil Dosyası Değerleri",
                        active: true,
                    },
                ],
            },
        },
        /* Fuel Storage */
        {
            path: "/FuelStorage/Order",
            name: "fuel-storage-order",
            component: () => import("@/views/fuel-storage/FuelStorageOrderView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_ORDERS_OPERATIONS"],
                icon: "swap_horiz",
                pageTitle: "Yakıt Siparişleri",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Yakıt Siparişleri", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/FuelWithdrawal",
            name: "fuel-storage-withdrawal",
            component: () => import("@/views/fuel-storage/components/FuelWithdrawalPage.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_OUTPUT_TRANSACTION_OPERATIONS"],
                icon: "arrow_back",
                pageTitle: "Yakıt Çıkışı",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Yakıt Çıkışı", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/FuelFilling",
            name: "fuel-storage-filling",
            component: () => import("@/views/fuel-storage/components/FuelFillingPage.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_INPUT_TRANSACTION_OPERATIONS"],
                icon: "arrow_forward",
                pageTitle: "Yakıt Girişi",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Yakıt Girişi", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/Transactions",
            name: "fuel-storage-transaction",
            component: () => import("@/views/fuel-storage/FuelStorageTransactionView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_TRANSACTION_VIEW_OPERATIONS"],
                icon: "swap_horiz",
                pageTitle: "Depo Hareketleri",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Depo Hareketleri", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/Transfer",
            name: "fuel-storage-transfer",
            component: () => import("@/views/fuel-storage/FuelStorageTransfer.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_TRANSFER_TRANSACTION_OPERATIONS"],
                icon: "compare_arrows",
                pageTitle: "Depolar Arası Transfer",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Depolar Arası Transfer", active: true },
                ],
            },
        },
        {
            path: "/FuelManagement/FuelFillingForm/:id?",
            name: "fuel-order-document-form",
            component: () => import("@/views/fuel-management/FuelOrderDocumentForm.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_ORDERS_OPERATIONS"],
                icon: "align_horizontal_left",
                pageTitle: "Sipariş Veri İşleme Formu",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Yakıt Siparişleri", active: true },
                    { text: "Sipariş Veri İşleme Formu", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/OutputReport",
            name: "fuel-output-report",
            component: () => import("@/views/fuel-storage/FuelOutputReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_TRANSACTION_OUTPUT_VIEW_OPERATIONS"],
                icon: "summarize",
                pageTitle: "Yakıt Çıkışları",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Yakıt Çıkışları", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/Reports/ByPlate",
            name: "fuel-consumption-by-plate",
            component: () => import("@/views/fuel-storage/reports/FuelConsumptionByPlateView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_CONSUMPTION_BY_PLATE_REPORT"],
                icon: "local_gas_station",
                pageTitle: "Plaka Bazlı Yakıt Alımları",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Plaka Bazlı Yakıt Alımları", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/Reports/ByDutyLocation",
            name: "fuel-consumption-by-duty-location",
            component: () => import("@/views/fuel-storage/reports/FuelConsumptionByDutyLocationView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_CONSUMPTION_BY_DUTY_LOCATION_REPORT"],
                icon: "location_on",
                pageTitle: "Görev Yeri Bazlı Yakıt Alımları",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Görev Yeri Bazlı Yakıt Alımları", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/Reports/ByBranch",
            name: "fuel-consumption-by-branch",
            component: () => import("@/views/fuel-storage/reports/FuelConsumptionByBranchView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_CONSUMPTION_BY_BRANCH_REPORT"],
                icon: "business",
                pageTitle: "Şube Bazlı Yakıt Alımları",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Şube Bazlı Yakıt Alımları", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/Reports/CompanyTotal",
            name: "fuel-consumption-company-total",
            component: () => import("@/views/fuel-storage/reports/FuelConsumptionCompanyTotalView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_CONSUMPTION_COMPANY_TOTAL_REPORT"],
                icon: "assessment",
                pageTitle: "Şirket Geneli Yakıt Alımları",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Şirket Geneli Yakıt Alımları", active: true },
                ],
            },
        },
        // {
        //   path: '/FuelStorage/TransactionDetails',
        //   name: 'fuel-storage-transaction-detail',
        //   component: () => import('@/views/fuel-storage/FuelStorageTransactionDetailView.vue'),
        //   meta: {
        //     requiresAuth: true,
        //     requiresRole: ["FUEL_STORAGE_TRANSACTION_DETAIL_LIST"],
        //     icon: 'list_alt',
        //     pageTitle: 'Depo Hareket Detayları',
        //     breadcrumb: [
        //       { text: 'Operasyonel Parametreler', active: true },
        //       { text: 'Akaryakıt Depoları', active: false, to: '/FuelStorage' },
        //       { text: 'Depo Hareket Detayları', active: true }
        //     ]
        //   }
        // },
        {
            path: "/FuelStorage",
            name: "fuel-storage",
            component: () => import("@/views/fuel-storage/FuelStorageView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                icon: "gas_meter",
                pageTitle: "Akaryakıt Depoları",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Tanımlamalar", active: true },
                    { text: "Akaryakıt Depoları", active: true },
                ],
            },
        },
        {
            path: "/IntegratedStorageClass",
            name: "integrated-storage-class",
            component: () => import("@/views/fuel-storage/IntegratedStorageClassView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                icon: "propane",
                pageTitle: "Entegre Depo Sınıfı",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Tanımlamalar", active: true },
                    { text: "Entegre Depo Sınıfı", active: true },
                ],
            },
        },
        {
            path: "/FuelStorageClass",
            name: "fuel-storage-class",
            component: () => import("@/views/fuel-storage/FuelStorageClassView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_PARAMETER_OPERATIONS"],
                icon: "propane",
                pageTitle: "Depo Sınıfı",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Tanımlamalar", active: true },
                    { text: "Depo Sınıfı", active: true },
                ],
            },
        },
        {
            path: "/Storage/FuelSupplier",
            name: "fuel-supplier",
            component: () => import("@/views/fuel-supplier/FuelSupplierView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_SUPPLIER_VIEW_OPERATIONS"],
                icon: "local_shipping",
                pageTitle: "Yakıt Tedarikçileri",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Yakıt Tedarikçileri", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/OccupancyReport",
            name: "fuel-storage-occupancy-report",
            component: () => import("@/views/fuel-storage/FuelStorageOccupancyReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_REPORT_VIEW_OPERATIONS"],
                icon: "data_usage",
                pageTitle: "Depo Doluluk Raporu",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Depo Doluluk Raporu", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/OccupancyBarChartReport",
            name: "fuel-storage-occupancy-bar-chart-report",
            component: () => import("@/views/fuel-storage/FuelStorageOccupancyBarChartView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_REPORT_VIEW_OPERATIONS"],
                icon: "bar_chart",
                pageTitle: "Depo Doluluk Seviyeleri",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Depo Doluluk Seviyeleri", active: true },
                ],
            },
        },
        {
            path: "/FuelStorage/StockStatusReport",
            name: "fuel-storage-stock-status-report",
            component: () => import("@/views/fuel-storage/FuelStorageStockStatusReportView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["FUEL_REPORT_VIEW_OPERATIONS"],
                icon: "stacked_bar_chart",
                pageTitle: "Depo Durum Raporu",
                breadcrumb: [
                    { text: "Yakıt Yönetimi", active: true },
                    { text: "Raporlar", active: true },
                    { text: "Depo Durum Raporu", active: true },
                ],
            },
        },
        // Website Yönetimi
        {
            path: "/Website/Dashboard",
            name: "website-dashboard",
            component: () => import("@/views/website/WebsiteDashboardView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WEBSITE_CONTENT_MANAGEMENT"],
                pageTitle: "Website Dashboard",
                icon: "dashboard",
                breadcrumb: [
                    { text: "Website İçerik Yönetim Sistemi", active: true },
                    { text: "Dashboard", active: true },
                ],
            },
        },
        {
            path: "/Website/Content",
            name: "website-content",
            component: () => import("@/views/website/ContentManagementView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WEBSITE_CONTENT_MANAGEMENT"],
                pageTitle: "İçerik Yönetimi",
                icon: "article",
                breadcrumb: [
                    { text: "Website İçerik Yönetim Sistemi", active: true },
                    { text: "İçerik Yönetimi", active: true },
                ],
            },
        },
        {
            path: "/Website/Language",
            name: "website-language",
            component: () => import("@/views/website/LanguageManagementView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WEBSITE_CONTENT_MANAGEMENT"],
                pageTitle: "Dil Yönetimi",
                icon: "translate",
                breadcrumb: [
                    { text: "Website İçerik Yönetim Sistemi", active: true },
                    { text: "Dil Yönetimi", active: true },
                ],
            },
        },
        {
            path: "/Website/Navigation",
            name: "website-navigation",
            component: () => import("@/views/website/NavigationManagementView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WEBSITE_CONTENT_MANAGEMENT"],
                icon: "menu",
                pageTitle: "Navigasyon Yönetimi",
                breadcrumb: [
                    { text: "Website İçerik Yönetim Sistemi", active: true },
                    { text: "Navigasyon Yönetimi", active: true },
                ],
            },
        },
        {
            path: "/Website/Configuration",
            name: "website-configuration",

            component: () => import("@/views/website/ConfigurationManagementView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WEBSITE_CONTENT_MANAGEMENT"],
                pageTitle: "Global Değerler",
                icon: "settings_suggest",
                breadcrumb: [
                    { text: "Website İçerik Yönetim Sistemi", active: true },
                    { text: "Global Değerler", active: true },
                ],
            },
        },
        {
            path: "/Website/Gallery",
            name: "website-gallery",

            component: () => import("@/views/website/GalleryManagementView.vue"),
            meta: {
                requiresAuth: true,
                requiresRole: ["WEBSITE_CONTENT_MANAGEMENT"],
                pageTitle: "Dosya Yönetimi",
                icon: "folder_open",
                breadcrumb: [
                    { text: "Website İçerik Yönetim Sistemi", active: true },
                    { text: "Dosya Yönetimi", active: true },
                ],
            },
        },
        {
            path: "/error-404",
            name: "error-404",
            component: () => import("@/views/error/Error404.vue"),
            meta: {
                layout: "full",
            },
        },
        {
            path: "/test",
            name: "test",
            component: () => import("@/views/Test.vue"),
            meta: {},
        },
        {
            path: "*",
            redirect: "error-404",
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.anonymous)) {
        if (Auth.isAuthenticated) {
            if (from) {
                router.push({ name: from.name });
            } else router.push({ name: "error-404" });
        } else next();
    } else next();
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (Auth.isAuthenticated) {
            if (to.matched.some((record) => record.meta.requiresRole)) {
                if (to.meta.requiresRole?.length > 0) {
                    if (Auth.hasRole(to.meta.requiresRole)) {
                        next();
                    } else router.push({ name: "error-404" });
                } else next();
            } else next();
        } else router.push({ name: "login", query: { redirect: to.path } });
    } else next();
});

router.afterEach(() => {
    const appLoading = document.getElementById("loading-bg");
    if (appLoading) {
        appLoading.style.display = "none";
    }
});

export default router;
